import { Group, HoverCard, ThemeIcon, Title } from '@mantine/core'
import { IconHelpCircle, IconInfoCircle } from '@tabler/icons-react'
import { useLanguage } from '../../stores/LanguageStore'
import image from '../../assets/unsubscribe_screenshot.png'

const UnsubscribeVariableTooltip = () => {
    const lang = useLanguage((s) => s.language);

    return (
        <HoverCard zIndex={1000} position='top'>
            <HoverCard.Target>
                <ThemeIcon>
                    <IconInfoCircle />
                </ThemeIcon>
            </HoverCard.Target>

            <HoverCard.Dropdown maw={500}>
                <Group wrap='nowrap'>
                    <IconHelpCircle size={24} />
                    <Title order={6}>
                        {lang.components.variable_manager.variable_tooltip.title_unsub}
                    </Title>
                </Group>
                <p>
                    <b>{lang.components.variable_manager.variable_tooltip.step} 01 :</b> {lang.components.variable_manager.variable_tooltip.step1_unsub}
                </p>
                <p>
                    <b>{lang.components.variable_manager.variable_tooltip.step} 02 :</b> {lang.components.variable_manager.variable_tooltip.step2_unsub}
                </p>
                <img src={image} alt="unsubscribe variable usage" />
            </HoverCard.Dropdown>
        </HoverCard>
    )
}

export default UnsubscribeVariableTooltip